import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { FiInfo } from "react-icons/fi";
import { HiOutlineLightBulb } from "react-icons/hi";
import { InfoTooltip } from "../_infoTooltip";

import "./index.scss";

interface SearchToggleProps {
  label?: string;
  defaultChecked?: boolean;
  theme?: "default" | "dark";
  onChange?: (checked: boolean) => void;
}

export function SearchToggle({
  label = "Usar todos os termos obrigatóriamente",
  defaultChecked = false,
  theme = "default",
  onChange,
}: SearchToggleProps) {
  const [checked, setChecked] = useState(defaultChecked);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const tooltipOpenRef = useRef(tooltipOpen);

  useEffect(() => {
    tooltipOpenRef.current = tooltipOpen;
  }, [tooltipOpen]);

  function handleToggle() {
    const next = !checked;

    setChecked(next);
    onChange?.(next);
  }

  useEffect(() => {
    function handleOutside(e: MouseEvent) {
      const target = e.target as Node;
      const isInside = wrapperRef.current?.contains(target);

      if (!isInside && tooltipOpenRef.current) {
        setTooltipOpen(false);
      }
    }

    document.addEventListener("mousedown", handleOutside);

    return () => {
      document.removeEventListener("mousedown", handleOutside);
    };
  }, []);

  return (
    <div className="root" ref={wrapperRef}>
      <span className={classNames("bulb", theme)} aria-hidden="true">
        <HiOutlineLightBulb />
      </span>

      <span className={classNames("label", theme)}>{label}</span>

      <div className="info">
        <button
          type="button"
          className={classNames("infoButton", theme)}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            setTooltipOpen((o) => !o);
          }}
        >
          <FiInfo />
        </button>

        <InfoTooltip open={tooltipOpen}>
          Retorne resultados que contenham <strong>todos os termos</strong> da
          pesquisa.
        </InfoTooltip>
      </div>

      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        className={classNames("switch", checked ? "switchOn" : "")}
        onClick={handleToggle}
      >
        <span className="thumb" />
      </button>
    </div>
  );
}
